// extracted by mini-css-extract-plugin
export default {"loading":"Select_loading__SiAlY"};